export * from "./qr-code-coupon.component";
